import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/shared/services/session.service'; // assuming you already have this

@Component({
  selector: 'app-how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrls: ['./how-it-works.component.scss']
})
export class HowItWorksComponent implements OnInit {

  constructor(
    public route: Router,
    private sessionService: SessionService
  ) {}

  @Input() showLearnMoreButton: boolean = true;
  @Input() showDivider: boolean = true;
  @Input() showHeader: boolean = true;
  @Input() disabled: boolean = false;
  @Input() isLoading: boolean = false;

  isPPI: boolean = false;
  isBilliant: boolean = false;

  sectionItems: any[] = [];

  // ngOnInit() {
  //   this.isPPI = this.sessionService.isPPI(); // ✅ detect if it's PPI

  //   this.sectionItems = [
  //     { 
  //       iconUrl: '../../../../assets/images/ups-money-manage.png', 
  //       title: '1. Earn Rewards and Cash', 
  //       description: 'Earn Rewards from your connected solutions and receive cash through claims and refunds.' 
  //     },
  //     { 
  //       iconUrl: this.isPPI 
  //         ? '../../../../assets/images/ups-payment-options-cc.png'   // ✅ swapped for PPI
  //         : '../../../../assets/images/ups-pay-bill.png', 
  //       title: '2. Redeem or Transfer', 
  //       description: 'Apply rewards and/or cash balance to the invoice. Cash balances can also be transferred to a designated bank account.' 
  //     },
  //     { 
  //       iconUrl: this.isPPI 
  //         ? '../../../../assets/images/ups-pay-bill.png'            // ✅ swapped for PPI
  //         : '../../../../assets/images/ups-payment-options-cc.png', 
  //       title: '3. Pay Balance', 
  //       description: 'Any remaining balance can be paid using your stored payment option.' 
  //     }
  //   ];

  //     this.sessionService.isBilliant$.subscribe(val => {
  //     this.isBilliant = val;
  //     console.log("Is Billiant Session:", this.isBilliant);
  //   });
  // }

  ngOnInit() {
  this.isPPI = this.sessionService.isPPI(); // ✅ detect if it's PPI

  // Subscribe to the Billiant flag FIRST
  this.sessionService.isBilliant$.subscribe(val => {
    this.isBilliant = val;
    console.log("Is Billiant Session:", this.isBilliant);

    // Now define the sectionItems INSIDE the subscription
    // This ensures we use the correct value for isBilliant
    this.sectionItems = [
      { 
        iconUrl: '../../../../assets/images/ups-money-manage.png', 
        // 1. CONDITIONAL TEXT FOR BILLIANT
        title: this.isBilliant ? '1. Earn Cash' : '1. Earn Rewards and Cash', 
        description: this.isBilliant 
          ? 'Get cash through claims.' 
          : 'Earn Rewards from your connected solutions and receive cash through claims and refunds.' 
      },
      { 
        iconUrl: this.isPPI 
          ? '../../../../assets/images/ups-payment-options-cc.png' 
          : '../../../../assets/images/ups-pay-bill.png', 
        title: '2. Redeem or Transfer', 
        description: this.isBilliant 
        ? 'Apply cash balance to the invoice. Cash balances can also be transferred to a designated bank account.' 
        : 'Apply rewards and/or cash balance to the invoice. Cash balances can also be transferred to a designated bank account.' 
      },
      { 
        iconUrl: this.isPPI 
          ? '../../../../assets/images/ups-pay-bill.png' 
          : '../../../../assets/images/ups-payment-options-cc.png', 
        title: '3. Pay Balance', 
        description: 'Any remaining balance can be paid using your stored payment option.' 
      }
    ];
  });
}

  learnMore() {
    this.route.navigate(['my-wallet', 'all-rewards', 'ways-to-earn']);
  }
}
